export const usd = (n: number, digits = 0) =>
  `$${n.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;

export const pct = (n: number) => `${Math.round(n * 100)}%`;

export const count = (n: number) => n.toLocaleString('en-US');

// Leads once a lead objective is in use, landing page views for traffic campaigns.
export function metaResults(m: { leads: number; landingPageViews: number }) {
  return m.leads > 0 ? { value: m.leads, label: 'Leads' } : { value: m.landingPageViews, label: 'Landing page views' };
}

export const costPer = (spend: number, results: number) => (results > 0 ? usd(spend / results, 2) : '—');
